
// Takes a UTC date and turns it into a JS Date()
export const parseDate = dateString => {
    if (!dateString) return null;
    // the 'T' is required for the JS parser to work.
    // the 'Z' forces UTC
    return new Date(dateString.replace(' ', 'T') + 'Z');
};

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const dateMonthShort = d => monthNames[d.getMonth()];

export const dateDayZeroPadded = d => d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();

